import image from './icon_lib_vip.png';

export const libVipIcon = image;
